<template>
  <!-- 左侧导航栏 -->

  <div class="leftNav" @click="homeclick()" :style="getThemeStyle()">
    <!-- 头像昵称 -->
    <!-- <div class="elecon">布尔清单</div> -->
    <div class="leftNav_info">
      <div class="leftNav_info_name">
        <img v-if="userInfo" :src="userInfo.avatar_url" alt="" />
        <span v-if="userInfo">{{ userInfo.nick_name }}</span>
      </div>
      <img
        src="../../assets/img/leftnav/setup.png"
        alt=""
        style="width: 21px; height: 21px; margin: 0"
        @click.stop="signOut()"
        v-if="getTheme() === '深色模式'"
      />
      <img
        src="../../assets/img/leftnav/setup1.png"
        alt=""
        style="width: 21px; height: 21px; margin: 0"
        @click.stop="signOut()"
        v-if="getTheme() === '普通模式'"
      />
      <div class="signgo" :class="dispno ? 'disbl' : ''">
        <div @click="setTheme()">
          <img src="../../assets/img/leftnav/zthf.png" />
          <span>{{ getTheme() }}</span>
        </div>
        <div @click="skinPeeler">
          <img src="../../assets/img/leftnav/zthf.png" />
          <span>主题换肤</span>
        </div>
        <div>
          <img src="../../assets/img/leftnav/gywm.png" />
          <span @click="dialogone = true">关于我们</span>
        </div>
        <div>
          <img src="../../assets/img/leftnav/zhaq.png" />
          <span @click="accountSecurity()">账户安全</span>
        </div>
        <div>
          <img src="../../assets/img/leftnav/tc.png" />
          <span @click="tologin()">退出登录</span>
        </div>
      </div>
    </div>

    <div ref="lefthgt" class="scrollbarY">
      <!-- 仪表盘 -->
      <div class="leftNav_catalog">
        <div
          class="list_title"
          @click="routerLinkTo({ path: '/index/instrument' })"
          :class="$route.path === '/index/instrument' && 'bgcor'"
        >
          <div>
            <img
              src="../../assets/img/home/left/instrument.png"
              style="height: 21px"
            />
            <span>仪表盘</span>
          </div>
        </div>
      </div>

      <!-- 列表 -->
      <div class="leftNav_catalog">
        <div
          @click="upClick(1)"
          :class="upbtn1 ? 'up-img1' : 'don-img1'"
          class="list_title"
        >
          <div>
            <img
              src="../../assets/img/home/left/detailedlist1.png"
              alt=""
              style="height: 21px"
              v-if="getTheme() === '普通模式'"
            />
            <img
              src="../../assets/img/home/left/detailedlist.png"
              alt=""
              style="height: 21px"
              v-if="getTheme() === '深色模式'"
            />
            <span>列表</span>
          </div>
          <i></i>
        </div>
        <ul class="mean" :class="upbtn1 ? '' : 'don-ul'">
          <!-- @click="listaAppearClick(1, '', 1)" -->
          <li
            @click="routerLinkTo({ path: '/index/home' })"
            :class="$route.path === '/index/home' && 'bgcor'"
            class="linumb"
            @mouseenter="hoverStyle($event)"
          >
            <div>
              <img
                src="../../assets/img/home/left/alltodo.png"
                alt=""
                v-if="getTheme() === '深色模式'"
              />
              <img
                src="../../assets/img/home/left/alltodo1.png"
                alt=""
                v-if="getTheme() === '普通模式'"
              />
              <span>全部待办</span>
            </div>
            <div v-if="tododata != ''">{{ tododata[0].count }}</div>
          </li>
          <!-- @click="listaAppearClick(10, '', 10)" -->
          <li
            @click="
              routerLinkTo({
                path: '/index/fourlists',
                query: { tet: '已过期' },
              })
            "
            :class="
              $route.path === '/index/fourlists' &&
              $route.query.tet === '已过期' &&
              'bgcor'
            "
            class="linumb"
            @mouseenter="hoverStyle($event)"
          >
            <div>
              <img
                src="../../assets/img/leftnav/unday.png"
                alt=""
                v-if="getTheme() === '深色模式'"
              />
              <!-- <img src="../../assets/img/leftnav/unday1.png" alt="" v-if="getTheme() === '普通模式'" /> -->
              <span>已过期</span>
            </div>
            <div v-if="tododata != ''">{{ tododata[2].count }}</div>
          </li>
          <!-- @click="listaAppearClick(2, '', 2)" -->
          <li
            @click="
              routerLinkTo({ path: '/index/fourlists', query: { tet: '今天' } })
            "
            class="linumb"
            @mouseenter="hoverStyle($event)"
            :class="
              $route.path === '/index/fourlists' &&
              $route.query.tet === '今天' &&
              'bgcor'
            "
          >
            <!-- :class="bgcolor == 2 ? 'bgcor' : ''" -->
            <div>
              <img
                src="../../assets/img/home/left/today.png"
                alt=""
                v-if="getTheme() === '深色模式'"
              />
              <img
                src="../../assets/img/home/left/today1.png"
                alt=""
                v-if="getTheme() === '普通模式'"
              />
              <span>今天</span>
            </div>
            <div v-if="tododata != ''">{{ tododata[1].count }}</div>
          </li>
          <!-- @click="listaAppearClick(3, '', 3)" -->
          <li
            @click="
              routerLinkTo({
                path: '/index/fourlists',
                query: { tet: '未来七天' },
              })
            "
            :class="
              $route.path === '/index/fourlists' &&
              $route.query.tet === '未来七天' &&
              'bgcor'
            "
            class="linumb"
            @mouseenter="hoverStyle($event)"
          >
            <!-- :class="bgcolor == 3 ? 'bgcor' : ''" -->
            <div>
              <img
                src="../../assets/img/home/left/future.png"
                alt=""
                v-if="getTheme() === '深色模式'"
              />
              <img
                src="../../assets/img/home/left/future1.png"
                alt=""
                v-if="getTheme() === '普通模式'"
              />
              <span>未来七天</span>
            </div>
            <div v-if="tododata != ''">{{ tododata[3].count }}</div>
          </li>
        </ul>
      </div>
      <!-- 视图 -->
      <div class="leftNav_catalog">
        <div
          @click="upClick(2)"
          :class="upbtn2 ? 'up-img1' : 'don-img1'"
          class="list_title"
        >
          <div>
            <img
              src="../../assets/img/home/left/view.png"
              alt=""
              v-if="getTheme() === '深色模式'"
            />
            <img
              src="../../assets/img/home/left/view1.png"
              alt=""
              v-if="getTheme() === '普通模式'"
            />
            <span>视图</span>
          </div>
          <i></i>
        </div>
        <!-- <ul class="mean" :class="upbtn2 ? '' : 'don-ul'"> -->
        <ul class="mean">
          <!-- @click="listaAppearClick(4, '', 4)" -->
          <li
            @mouseenter="hoverStyle($event)"
            @click="routerLinkTo({ path: '/index/fourquadrants' })"
            :class="$route.path === '/index/fourquadrants' && 'bgcor'"
          >
            <!-- :class="bgcolor == 4 ? 'bgcor' : ''" -->
            <img
              src="../../assets/img/home/left/quadrants.png"
              alt=""
              v-if="getTheme() === '深色模式'"
            />
            <img
              src="../../assets/img/home/left/quadrants1.png"
              alt=""
              v-if="getTheme() === '普通模式'"
            />
            <span>四象限</span>
          </li>
          <!-- @click="listaAppearClick(5, '', 5)" -->
          <li
            @click="routerLinkTo({ path: '/index/weeks' })"
            @mouseenter="hoverStyle($event)"
            :class="$route.path === '/index/weeks' && 'bgcor'"
          >
            <!-- :class="bgcolor == 5 ? 'bgcor' : ''" -->
            <img
              src="../../assets/img/home/left/weekview.png"
              alt=""
              v-if="getTheme() === '深色模式'"
            />
            <img
              src="../../assets/img/home/left/weekview1.png"
              alt=""
              v-if="getTheme() === '普通模式'"
            />
            <span>周视图</span>
          </li>
          <!-- @click="listaAppearClick(6, '', 6)" -->
          <li
            @click="routerLinkTo({ path: '/index/month' })"
            :class="$route.path === '/index/month' && 'bgcor'"
            @mouseenter="hoverStyle($event)"
          >
            <!-- :class="bgcolor == 6 ? 'bgcor' : ''" -->
            <img
              src="../../assets/img/home/left/monthlyview.png"
              alt=""
              v-if="getTheme() === '深色模式'"
            />
            <img
              src="../../assets/img/home/left/monthlyview1.png"
              alt=""
              v-if="getTheme() === '普通模式'"
            />
            <span>月视图</span>
          </li>
          <!-- @click="listaAppearClick(7, '', 7)" -->
          <li
            @click="routerLinkTo({ path: '/index/listview' })"
            @mouseenter="hoverStyle($event)"
            :class="$route.path === '/index/listview' && 'bgcor'"
          >
            <!-- :class="bgcolor == 7 ? 'bgcor' : ''" -->
            <img
              src="../../assets/img/home/left/listview.png"
              alt=""
              v-if="getTheme() === '深色模式'"
            />
            <img
              src="../../assets/img/home/left/listview1.png"
              alt=""
              v-if="getTheme() === '普通模式'"
            />
            <span>清单视图</span>
          </li>
          <!-- <li
            @click="listaAppearClick(11, '', 11)"
            :class="bgcolor == 11 ? 'bgcor' : ''"
            @mouseenter="hoverStyle($event)"
          >
            <img
              src="../../assets/img/home/left/listview.png"
              alt=""
              v-if="getTheme() === '深色模式'"
            />
            <img
              src="../../assets/img/home/left/listview1.png"
              alt=""
              v-if="getTheme() === '普通模式'"
            />
            <span>分析总结</span>
          </li> -->
          <!-- @click="listaAppearClick(8, '', 8)" -->
          <li
            @click="routerLinkTo({ path: '/index/cards' })"
            :class="$route.path === '/index/cards' && 'bgcor'"
          >
            <!-- :class="bgcolor == 8 ? 'bgcor' : ''" -->
            <img src="../../assets/img/home/left/cardview.png" alt="" />
            <span>卡片视图</span>
          </li>
          <li
            @click="routerLinkTo({ path: '/index/timeview' })"
            :class="$route.path === '/index/timeview' && 'bgcor'"
          >
            <img src="../../assets/img/home/left/timeview.png" alt="" />
            <span>时间轴视图</span>
          </li>
        </ul>
      </div>
      <!-- 清单 -->
      <div class="leftNav_catalog">
        <div
          @click="upClick(3)"
          :class="upbtn3 ? 'up-img1' : 'don-img1'"
          class="list_title"
        >
          <div>
            <img
              src="../../assets/img/home/left/detailedlist.png"
              alt=""
              style="height: 21px"
              v-if="getTheme() === '深色模式'"
            />
            <img
              src="../../assets/img/home/left/detailedlist1.png"
              alt=""
              style="height: 21px"
              v-if="getTheme() === '普通模式'"
            />

            <span>清单</span>
          </div>
          <i></i>
        </div>

        <ul class="mean" :class="upbtn3 ? '' : 'don-ul'">
          <!-- :class="bgcolor == index + 9 ? 'bgcor' : ''" -->
          <li
            v-for="(item, index) in list3"
            @keypress.enter="setNavInfo(item, $event)"
            @mouseenter="hoverStyle($event)"
            :key="index"
            class="linumb"
            @contextmenu.prevent="show111($event, item, index)"
            @click="
              routerLinkTo({
                path: '/index/fourlists',
                query: {
                  tet: '自定义',
                  from_id: item.from_id,
                  name: item.name,
                },
              })
            "
            :class="
              $route.path === '/index/fourlists' &&
              $route.query.from_id == item.from_id &&
              'bgcor'
            "
          >
            <!-- @click="listaAppearClick(9, item, index + 9)" -->
            <div style="flex: 1">
              <img
                src="../../assets/img/home/left/life.png"
                alt=""
                v-if="getTheme() === '深色模式'"
              />
              <img
                src="../../assets/img/home/left/life1.png"
                alt=""
                v-if="getTheme() === '普通模式'"
              />
              <div
                style="flex: 1"
                :ref="'list' + index"
                :contenteditable="currentContenteditableid === item.from_id"
                @blur="setNavInfo(item,$event)"
                
              >
                {{ item.name }}
              </div>
            </div>
            <div>{{ item.count }}</div>
          </li>
          <li class="addlist" @click="addlist">
            <img
              src="../../assets/img/leftnav/addto.png"
              alt=""
              v-if="getTheme() === '深色模式'"
            />
            <!-- <img src="../../assets/img/leftnav/addto1.png" alt="" v-if="getTheme() === '普通模式'"  /> -->
            <span>添加清单</span>
          </li>
        </ul>
        <div
          v-if="visible"
          class="idpop"
          :style="{ top: tranTop, left: '162px' }"
        >
          <div @click="editnav()">
            <div>
              <img src="../../assets/img/home/center/edit.png" alt="" />
              <span :style="getTheme() == '普通模式' && 'color:#000;'"
                >编辑清单</span
              >
            </div>
          </div>

          <div @click="dletnav()">
            <img src="../../assets/img/home/center/deleter.png" alt="" />
            <span
              :style="getTheme() == '普通模式' && 'color:#000;'"
              style="color: #d00"
              >删除清单</span
            >
          </div>
        </div>

        <my-dialog
          :boxStyle="
            getTheme() == '普通模式'
              ? 'width: 560px;' + boxDarkStyle()
              : 'width: 560px;'
          "
          :visible.sync="dialogVisible"
          :show-close="false"
          :modal="false"
        >
          <span slot="title">添加清单</span>
          <div class="add_dialog">
            <img
              src="../../assets/img/home/left/life.png"
              alt=""
              v-if="getTheme() === '深色模式'"
            />
            <img
              src="../../assets/img/home/left/life1.png"
              alt=""
              v-if="getTheme() === '普通模式'"
            />
            <input
              :style="getTheme() == '普通模式' && boxDarkStyle()"
              type="text"
              placeholder="请输入清单列表名称"
              v-model="addtitle"
            />
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="dialogVisible = false"
              >&nbsp;&nbsp;取&nbsp;消&nbsp;&nbsp;</el-button
            >
            <el-button size="small" type="primary" @click="determineAdd"
              >&nbsp;&nbsp;创&nbsp;建&nbsp;&nbsp;</el-button
            >
          </span>
        </my-dialog>

        <el-dialog
          title="关于"
          :visible.sync="dialogone"
          width="30%"
          class="tsabout"
        >
          <span style="font-size: 14px; font-weight: normal">
            <div>布尔清单&nbsp;&nbsp;v1.3.0</div>
            <div>公司：浙江舒博特网络科技有限公司</div>
            <div>官网：http://www.10qu.com.cn</div>
            <div>当前Windows版本：{{ windowsVersion }}</div>
            <div>当前Electron版本：{{ electron }}</div>
            <div>当前Chrome版本：{{ chrome }}</div>
          </span>

          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogone = false"
              >确 定</el-button
            >
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import bus from "./../../util/bus";
import { mapMutations, mapGetters } from "vuex";
import ElDialog from "../../set-element-ui/dialog";
export default {
  data() {
    return {
      dialogone: false,
      addtitle: "",
      //控制中间子组件出现哪个
      listaAppear: 1,
      dispno: false,
      //当前点击条目
      indexlist: -1,
      //控制删除盒子出现隐藏
      visible: false,
      tranTop: "",
      navid: "",
      //收起按钮
      upbtn1: true,
      upbtn2: true,
      upbtn3: true,
      //固定清单
      tododata: [],
      //自定义清单
      list3: [],
      user: "",
      dialogVisible: false,
      bgcolor: 1,
      //查询到的用户信息
      userInfo: {},
      windowsVersion: "",
      electron: "",
      chrome: "",
      currentContenteditableid: null,
      that: this,
    };
  },
  directives: {
    focus: {
      // 指令的定义
      inserted: (el, data) => {
        console.log(el, data, "data");
        const that = data.value;
        that.$on("focus", () => {
          that.$nextTick(() => {
            el.focus();
          });
        });
      },
    },
  },
  components: {
    MyDialog: ElDialog,
  },

  created() {
    this.navnumb();
    this.bgcolor = sessionStorage.getItem("colonum");
    this.UserInformation();
    bus.$on("refreshLeft", () => {
      this.navnumb();
    });
    // this.chrome = localStorage.getItem("chrome");
    // this.electron = localStorage.getItem("electron");
    var userAgentInfor = navigator.userAgent.toLowerCase();
    console.log(userAgentInfor, "123456");
    this.windowsVersion = userAgentInfor.substr(
      userAgentInfor.indexOf("windows nt ") + 11,
      4
    );
    this.chrome = userAgentInfor.substr(
      userAgentInfor.indexOf("chrome/") + 7,
      13
    );
    this.electron = userAgentInfor.substr(
      userAgentInfor.indexOf("electron/") + 9,
      6
    );
    console.log("windows" + this.windowsVersion, "版本号");
    console.log(this.chrome, process.versions.electron);
    console.log(this.electron);
  },

  mounted() {
    //动态计算清单高度&赋值
    // this.qdheight();
  },
  watch: {
    qingdanHeight(val) {
      console.error(val);
    },
    userInfo: {
      handler(val) {
        sessionStorage.setItem("usobj", JSON.stringify(val));
        this.user = JSON.parse(sessionStorage.getItem("usobj"));
      },
    },
  },
  methods: {
    ...mapGetters("theme", ["getThemeStyle", "getTheme"]),
    ...mapMutations("theme", ["setTheme", "hoverStyle"]),
    routerLinkTo(router) {
      this.$router.replace(router);
    },

    //添加清单
    addlist() {
      this.dialogVisible = true;
    },
    abot() {},
    //添加清单点击确认
    determineAdd() {
      let header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
      };
      let data = {
        name: this.addtitle,
      };
      this.$api
        .addtodo(data, header)
        .then((res) => {
          console.log(res, "添加清单");
          this.navnumb();
          this.dialogVisible = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    show111(e, item, index) {
      this.currentContenteditableid = null;
      console.log(e, item, index, this.indexlist);
      this.navid = item.from_id;
      if (index == this.indexlist) {
        this.visible = true;
        // this.visible = true
      } else {
        this.indexlist = index;
        this.visible = true;
      }
      let tlet = document.getElementsByClassName("idpop");
      console.log(e.pageX, e.pageY);

      if (document.body.clientHeight > e.pageY + 20 + 100) {
        // 显示在上
        this.tranTop = e.pageY + 20 + "px";
      } else {
        // 显示在下
        this.tranTop = e.pageY + -120 + "px";
      }
    },
    dletnav() {
      let header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
      };
      this.$api
        .deleteClassification(this.navid, header)
        .then((res) => {
          console.log(res, "删除分类");
          this.navnumb();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 编辑导航栏
    editnav() {
      this.currentContenteditableid = this.navid;
      this.$emit("focus");
    },
    
    // 回车、失去焦点触发修改
    setNavInfo(item, e) {
      console.log(item,e.target.textContent, "修改的参数");
      this.currentContenteditableid = null;
      let header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
      };
      let data = {
        id: item.from_id,
        name: e.target.textContent,
      };
      this.$api
        .putClassification(data, header)
        .then((res) => {
          console.log(res, "修改分类");
          this.navnumb();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 查询条目数
    navnumb() {
      console.log("调用");
      let header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
      };
      this.$api
        .navnumbar("", header)
        .then((res) => {
          console.log(res, "查询条目数");
          this.tododata = res.data.result[0].todo_data;
          this.list3 = res.data.result[1].todo_data;
          this.qdheight();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    upClick(index) {
      this["upbtn" + index] = !this["upbtn" + index];
      console.log(this["upbtn" + index], "1111111111");
      console.log(document.getElementsByClassName("mean"));
      let dom = document.getElementsByClassName("mean")[index - 1];
      let height;
      switch (index) {
        case 1:
          height = 180;
          break;
        case 2:
          height = 270;
          break;
        case 3:
          height = this.qingdanHeight;
          break;
      }
      console.log(height, "2222222222222222");
      this["upbtn" + index]
        ? (dom.style.height = height + "px")
        : (dom.style.height = "0px");
      console.log(dom, "333333333333");
      console.log(dom.style.height, "444444444444");
    },
    //导航栏点击事件
    listaAppearClick(index, todoid, colorbgc) {
      console.log(colorbgc, "添加背景色");
      sessionStorage.setItem("colonum", colorbgc);
      console.log(sessionStorage.getItem("colonum"), 888888888888888);
      this.bgcolor = sessionStorage.getItem("colonum");
      this.listaAppear = index;
      if (index == 1) {
        this.$router.push({ name: "home" });
      } else if (index == 4) {
        this.$router.push({ name: "fourquadrants" });
      } else if (index == 5) {
        this.$router.push({ name: "weeks" });
      } else if (index == 7) {
        this.$router.push({ name: "listview" });
      } else if (index == 2) {
        this.$router.push({ name: "fourlists", query: { tet: "今天" } });
      } else if (index == 3) {
        this.$router.push({ name: "fourlists", query: { tet: "未来七天" } });
      } else if (index == 6) {
        this.$router.push({ name: "month" });
      } else if (index == 11) {
        this.$router.push({ name: "sumup" });
      } else if (index == 10) {
        this.$router.push({ name: "fourlists", query: { tet: "已过期" } });
      } else if (index == 9) {
        this.$router.push({
          name: "fourlists",
          query: { tet: "自定义", from_id: todoid.from_id, name: todoid.name },
        });
      }
    },
    //查询用户头像昵称
    UserInformation() {
      let header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
      };
      this.$api
        .queryUserNickImg("", header)
        .then((res) => {
          console.log(res, "侧菜单的用户信息");
          this.userInfo = {
            avatar_url: res.data.results.avatar_url,
            nick_name: res.data.results.nick_name,
          };
          console.log(this.userInfo, "用户信息");
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //查询高度
    qdheight() {
      this.qingdanHeight = (this.list3.length + 1) * 45;
      let dom3H = document.getElementsByClassName("mean")[2];
      dom3H.style.height = this.qingdanHeight + "px";
    },
    //退出登录
    tologin() {
      localStorage.clear();
      sessionStorage.removeItem("token");
      this.$router.push({ name: "login" });
    },
    //账户安全
    accountSecurity() {
      this.$router.push({ name: "accountset" });
    },
    //主题换肤
    skinPeeler() {
      this.$router.push({ name: "skinpeeler" });
    },
    signOut() {
      this.dispno = !this.dispno;
    },
    // 监听home页面的点击事件
    homeclick() {
      this.visible = false;
      this.dispno = false;
    },
    boxDarkStyle() {
      return `
              background-color: #f2f4f8;
              color: #fff;
              `;
      // box-shadow: 0px 9px 35px 0px
      // rgba(0, 0, 0, 0.31);
    },
  },
};
</script>

<style lang="scss">
.leftNav {
  height: 100%;
  width: 19%;
  min-width: 288px;
  min-height: 288px;
  padding-top: 20px;
  // 颜色先去掉，由js来控制外层继承下来
  // background-color: #fff;
  font-size: 16px;
  font-weight: bold;
  //   font-family: PingFang-SC-Medium;

  .elecon {
    height: 25px;
    line-height: 25px;
    font-size: 12px;
    padding-left: 20px;
    margin-bottom: 26px;
    font-weight: normal;
    z-index: 999999;
  }
  .leftNav_info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 15px;
    padding: 0 30px 0 15%;
    position: relative;
    .leftNav_info_name {
      display: flex;
      align-items: center;
    }
    .disbl {
      display: block !important;
    }
    .signgo {
      display: none;
      position: absolute;
      z-index: 999;
      height: auto;
      width: 180px;
      background-color: #fff;
      top: 50px;
      right: 0;
      box-shadow: 0px 4px 32px 3px rgba(0, 0, 0, 0.19);
      div {
        display: flex;
        padding: 0 20px;
        align-items: center;
        line-height: 40px;
        // color: #999;
        font-weight: normal;
        color: #333333;
        font-size: 15px;
        img {
          width: 15px;
          height: 15px;
          margin-right: 18px;
          border-radius: initial;
        }
      }
      // div:hover {
      //   background-color: #f2f4f8;
      // }
    }

    img {
      width: 37px;
      height: 37px;
      border-radius: 50%;
      margin-right: 15px;
    }
  }
  .idpop {
    position: absolute;
    z-index: 2000;
    // background-color: #fff;
    display: block !important;
    // box-shadow: 0px 4px 32px 3px rgba(0, 0, 0, 0.19);
    > div {
      cursor: pointer;
      height: 50px;
      width: 210px;
      background-color: #eee;
      &:hover {
        background-color: #ddd;
      }
      // box-shadow: 0px 4px 32px 3px rgba(0, 0, 0, 0.19);
      display: flex;
      align-items: center;
      img {
        margin: 0 30px;
      }
    }
  }
  .scrollbarY {
    overflow-y: auto;
    height: calc(100% - 40px);
    //前两个菜单高度固定
    > :nth-child(1) {
      overflow: hidden;
      // .mean {
      //   // height: 180px;
      // }
    }
    > :nth-child(2) {
      .mean {
        // height: 275px;
        overflow: hidden;
      }
    }
  }
  .scrollbarY::-webkit-scrollbar {
    width: 3px;
  }
  .scrollbarY::-webkit-scrollbar-thumb {
    border-radius: 10px;
    // background: rgba(0, 0, 0, 0.2);
  }

  .leftNav_catalog {
    line-height: 40px;
    img {
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }
    div {
      display: flex;
      align-items: center;
    }
    .list_title {
      margin: 20px 0 10px 0;
      display: flex;
      justify-content: space-between;
      padding: 0 30px 0 15%;
      i {
        display: inline-block;
        width: 10px;
        height: 6px;
        background-size: 100% 100%;
      }
    }
    .up-img1 {
      i {
        background-image: url(../../assets/img/home/left/putitaway.png);
      }
    }
    .don-img1 {
      i {
        background-image: url(../../assets/img/home/left/open.png);
      }
    }
    ul {
      transition: all 0.5s;
      overflow: hidden;

      li {
        height: 45px;
        line-height: 45px;
        display: flex;
        align-items: center;
        padding: 0 15% 0 25%;
      }

      // .addlist {
      //   width: 80%;
      //   background-color: #4973f5;
      //   border-radius: 10px;
      //   padding: 0;
      //   margin: 0 auto;
      //   justify-content: center;
      //   color: #fff;
      //   cursor: pointer;
      // }
      // li:hover {
      //   // background-color: #f5f8fe !important;
      // }
    }
    .linumb {
      justify-content: space-between;
    }
    .el-dialog {
      display: flex;
      flex-direction: column;
      align-items: baseline;
      padding: 20px;
    }
    .el-dialog__footer {
      width: 100%;
      display: flex;
      justify-content: flex-end;
    }
    .el-dialog__body {
      width: 100%;
    }
    .add_dialog {
      width: 100%;
      height: 39px;
      line-height: 39px;
      img {
        width: 15px;
        height: 13px;
      }
      input {
        width: 100%;
        height: 100%;
        border: none;
        color: #333;
        font-size: 15px;
        border-bottom: 1px solid #dfe2e8;
      }
      input::-webkit-input-placeholder {
        color: #999;
      }
    }
  }
  .tsabout {
    .el-dialog {
      // height: 350px;
      height: 350px;
    }
    .el-dialog__header {
      padding-top: 0;
    }
    .el-dialog__body {
      padding: 0 0 0 20px;
      flex-wrap: wrap;
    }
    .el-dialog__footer {
      padding: 0;
    }
  }
  .bgcor {
    background-color: #f2f4f8 !important;
  }
}
</style>